import {AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {DecimalPipe} from "@angular/common";

@Component({
    selector: 'app-building-condition',
    templateUrl: './building-condition.component.html',
    providers: [DecimalPipe],
    standalone: false
})
export class BuildingConditionComponent implements OnInit, AfterViewInit {
  /**
   * current building is on stage
   */
  @Input() value: number;

  /**
   * minimum value
   */
  @Input() min: number;

  /**
   * avarage value
   */
  @Input() avg: number;

  /**
   * maximum value
   */
  @Input() max: number;

  /**
   * Switch or showing apartement building vs. single family home
   */
  @Input() isApartementBuilding: boolean = true;

  /**
   * Switch to show colored vs. not colored floor in apartement building
   */
  @Input() markFloorInApartement: boolean = false;

  /**
   * Prefix for all used textkeys
   */
  @Input() textKeyPrefix: string = 'smarthec.auswerten.condition';

  /**
   * extra postfix for the hinttext
   */
  @Input() hintTextPostfix: string = '';

  /**
   * Placeholder used in all texts
   */
  @Input() textPlaceholder: any = {};

  /**
   * toggle for the average building
   */
  @Input() showAverage: boolean = true;

  /**
   * Eventemitter that is called if the stage is set. Stage can be a number from 0 to 4
   */
  @Output() stageSet: EventEmitter<number> = new EventEmitter<number>();

  /**
   * The DOM element where the build is placed in
   */
  @ViewChild('building') buildingWrapper: ElementRef;

  /**
   * current visible stage
   */
  stage: number;

  /**
   * The several styges where this building coul be placed
   */
  stages: string[] = [];

  /**
   * toggle if a text is available (textkey filled)
   */
  hasHint: boolean = false;

  /**
   * toggle for the hint text
   */
  showHint: boolean = false;

  /**
   * constructor
   * @param translate
   * @param decimalPipe
   */
  constructor(private translate: TranslateService, private decimalPipe: DecimalPipe) {
  }

  /**
   * Initialize the stages we want to show and the current active stage
   */
  ngOnInit(): void {
    // the middle is +/i 10% of the avarage
    const avgDeviationMin = Math.round(this.avg * .9);
    const avgDeviationMax = Math.round(this.avg * 1.1);

    this.stages.push('<' + Math.round(this.min));
    this.stages.push(Math.round(this.min) + '-' + (avgDeviationMin - 1));
    this.stages.push(avgDeviationMin + '-' + avgDeviationMax);
    this.stages.push((avgDeviationMax +1) + '-' + Math.round(this.max));
    this.stages.push('>' + Math.round(this.max));

    if(Math.round(this.value) < this.min) {
      this.stage = 0;
    }
    else if(Math.round(this.value) < avgDeviationMin) {
      this.stage = 1;
    }
    else if(Math.round(this.value) > this.max) {
      this.stage = 4;
    }
    else if(Math.round(this.value) > avgDeviationMax) {
      this.stage = 3;
    }
    else {
      this.stage = 2;
    }

    // emit event that the stage is set
    this.stageSet.emit(this.stage);

    // check if we have a hint text
    const hintTextkey = this.textKeyPrefix + '.yourbuilding.hint' + this.hintTextPostfix;
    this.translate.get(hintTextkey).subscribe(data => {
      this.hasHint = data && data !== hintTextkey;
    });

    // add some placeholder
    setTimeout(() => {
      // avoind angular errors because value has changed
      this.textPlaceholder['evkw'] = this.decimalPipe.transform(this.value, '0.0-0');
    }, 0)
  }

  /**
   * @inheritDoc
   */
  ngAfterViewInit() {
    // place a copy of the building as average in grey on the second stage
    this.initAverageBuilding();
  }

  /**
   * shot the average building, if activated
   */
  initAverageBuilding(): void {
    if(this.showAverage === true) {
      const averageWrapper = document.createElement("div");
      averageWrapper.classList.add('average-wrapper');

      if(this.stage < 2) {
        averageWrapper.classList.add('higher');
      }

      const duplicate = this.buildingWrapper.nativeElement.children[0].cloneNode(true);
      averageWrapper.append(duplicate);
      this.buildingWrapper.nativeElement.after(averageWrapper);
    }
  }

}
